module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-91276922-2"},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Kernelgonnapanic.pl - technologie webowe na luzie","short_name":"Kernelgonnapanic.pl","start_url":"/","background_color":"#ffffff","theme_color":"#E0246C","display":"minimal-ui","icon":"content/assets/submark_kernelgonnapanic.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"5320847a5a367439008726b746b88d18"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
